import React from 'react';

const Impressum = () => {
    return (
        <div className="container mx-auto px-4 py-8 max-w-4xl">
            <h1 className="text-3xl font-bold mb-6 text-gray-900 dark:text-gray-100">Impressum</h1>

            <div className="bg-white dark:bg-[#1e1e1e] p-6 rounded-xl shadow-sm border border-gray-200 dark:border-gray-800 space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-4 text-gray-800 dark:text-gray-200">
                    <div className="font-bold text-gray-500 dark:text-gray-400 uppercase text-sm tracking-wider">BETREIBER</div>
                    <div>Felix Brabetz</div>

                    <div className="font-bold text-gray-500 dark:text-gray-400 uppercase text-sm tracking-wider">KONTAKT & SUPPORT</div>
                    <div>
                        Felix Brabetz<br />
                        E-Mail: <a href="mailto:felix.brabetz@plantlix.de" className="text-plantlix-600 hover:underline">felix.brabetz@plantlix.de</a>
                    </div>

                    <div className="font-bold text-gray-500 dark:text-gray-400 uppercase text-sm tracking-wider">VERANTWORTLICH</div>
                    <div>
                        Inhaltlich Verantwortlicher gemäß § 18 Abs. 2 MStV:<br />
                        Felix Brabetz
                    </div>

                    <div className="font-bold text-gray-500 dark:text-gray-400 uppercase text-sm tracking-wider">COPYRIGHT</div>
                    <div>
                        © {new Date().getFullYear()} Felix Brabetz. Alle Rechte vorbehalten.
                    </div>

                    <div className="font-bold text-gray-500 dark:text-gray-400 uppercase text-sm tracking-wider">UPDATES</div>
                    <div>
                        <a href="/changelog" className="text-plantlix-600 hover:underline">Aktueller Changelog</a>
                    </div>
                </div>

                <div className="mt-8 p-4 bg-gray-50 dark:bg-[#1e1e1e] rounded-lg border border-gray-100 dark:border-gray-700 text-sm text-gray-600 dark:text-gray-400 font-medium">
                    Hinweis: Diese Lernplattform stellt keine Rechts- oder Fachberatung dar. Alle Angaben ohne Gewähr.
                </div>
            </div>
        </div>
    );
};

export default Impressum;
